import { useContext } from 'react';
import Image from 'next/future/image';
import cn from 'classnames';
import { QsContext } from '@/lib/use-qs';
import ChevronDown from '@/public/icons/collection/chevron_down.svg';

export default function SortSelect(props: Readonly<{ className: string }>) {
  const [qs, updateQs] = useContext(QsContext);

  return (
    <div
      className={cn(
        'relative flex h-full items-center justify-center',
        props.className,
      )}
    >
      <select
        className="h-full appearance-none bg-transparent py-2 pl-3 pr-3 text-sm outline-none 3xs:pr-8 lg:border"
        value={`${qs.sort || 'undefined'}#${qs.order || 'asc'}`}
        onChange={(e) => {
          const [sort, order] = e.target.value.split('#');

          if (sort === 'undefined') {
            updateQs({ order: undefined, sort: undefined });
          } else {
            updateQs({
              order,
              sort,
            });
          }
        }}
      >
        <option value="undefined#asc">Relevance</option>
        <option value="price#asc">Price (Low to High)</option>
        <option value="price#desc">Price (High to Low)</option>
      </select>
      <div className="absolute right-3 top-1/2 hidden w-[10px] -translate-y-1/2 3xs:block">
        <Image
          src={ChevronDown}
          loading="eager"
          alt="down"
          className="h-full w-full object-contain"
        />
      </div>
    </div>
  );
}
